/**
 * Throttle function - limits execution to once per delay period
 * @param {Function} fn - Function to throttle
 * @param {number} delay - Delay in milliseconds
 * @returns {Function} Throttled function
 */
export const throttle = (fn, delay = 200) => {
  let lastCall = 0;

  return (...args) => {
    const now = Date.now();

    if (now - lastCall >= delay) {
      lastCall = now;
      fn(...args);
    }
  };
};

/**
 * Debounce with requestAnimationFrame - optimal for visual updates
 * @param {Function} fn - Function to debounce
 * @returns {Function} Debounced function
 */
export const rafDebounce = (fn) => {
  let rafId = null;

  return (...args) => {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }

    rafId = requestAnimationFrame(() => {
      fn(...args);
      rafId = null;
    });
  };
};

export const icons = [
  'arrow-left',
  'arrow-right',
  'arrow-right-s',
  'arrow-down',
  'bag',
  'bike',
  'check',
  'check-fill',
  'clock',
  'close',
  'delete',
  'dots',
  'download',
  'facebook',
  'file',
  'filter',
  'funding',
  'help',
  'home',
  'image',
  'info',
  'instagram',
  'insurance',
  'layout',
  'like',
  'link',
  'lock',
  'map-pin',
  'mail-send',
  'menu',
  'mileage',
  'minus',
  'news',
  'open',
  'original-parts',
  'parameters',
  'phone',
  'plus',
  'premium',
  'profile',
  'question',
  'quote',
  'refresh',
  'rent-bike',
  'rent-key',
  'sale',
  'search',
  'services',
  'share',
  'shop',
  'social',
  'sort',
  'substract',
  't-box',
  'text',
  'time',
  'trade-in',
  'transportation',
  'trials',
  'upload',
  'video',
  'wallet',
  'warranty',
  'workshop',
];

/**
 * Initialize text toggle (read more/less) functionality
 * @param {string} prefix - Component prefix (e.g., 'articleHeader', 'mainHeader')
 */
export const initTextToggle = (prefix) => {
  const triggers = document.querySelectorAll(`.js-${prefix}-trigger`);

  for (const trigger of triggers) {
    const textContainer = trigger.closest(`.js-${prefix}-text`);

    if (!textContainer) {
      continue;
    }

    trigger.addEventListener('click', () => {
      textContainer.classList.toggle('-more');
    });
  }
};

export const attachSwipeEvents = (elt, handlers = {}) => {
  let touchstartX = 0;
  let touchstartY = 0;
  let touchendX = 0;
  let touchendY = 0;
  let threshold = 50;

  elt.addEventListener('touchstart', (event) => {
    touchstartX = event.touches.item(0).screenX;
    touchstartY = event.touches.item(0).screenY;
  }, false);

  elt.addEventListener('touchend', (event) => {
    touchendX = event.changedTouches.item(0).screenX;
    touchendY = event.changedTouches.item(0).screenY;
    handleGesture();
  }, false);

  const handleGesture = () => {
    const { onSwipeLeft, onSwipeRight, onSwipeUp, onSwipeDown, onTap } = handlers;

    if (onSwipeLeft && touchendX < touchstartX - threshold) {
      onSwipeLeft();
    }

    if (onSwipeRight && touchendX > touchstartX + threshold) {
      onSwipeRight();
    }

    if (onSwipeUp && touchendY < touchstartY - threshold) {
      onSwipeUp();
    }

    if (onSwipeDown && touchendY > touchstartY + threshold) {
      onSwipeDown();
    }

    if (onTap && touchendY == touchstartY) {
      onTap();
    }
  };
};
